import { Routes, Route } from 'react-router-dom';
import { Toaster } from '@devkit/ui';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import ToolsPage from './pages/ToolsPage';
import JsonFormatterPage from './pages/tools/JsonFormatterPage';
import JsonValidatorPage from './pages/tools/JsonValidatorPage';
import JsonMinifierPage from './pages/tools/JsonMinifierPage';
import JsonViewerPage from './pages/tools/JsonViewerPage';
import JsonToYamlPage from './pages/tools/JsonToYamlPage';
import YamlToJsonPage from './pages/tools/YamlToJsonPage';
import Base64Page from './pages/tools/Base64Page';
import UrlEncoderPage from './pages/tools/UrlEncoderPage';
import HtmlEntityEncoderPage from './pages/tools/HtmlEntityEncoderPage';
import BinaryEncoderPage from './pages/tools/BinaryEncoderPage';
import HexEncoderPage from './pages/tools/HexEncoderPage';
import JwtDecoderPage from './pages/tools/JwtDecoderPage';
import HashGeneratorPage from './pages/tools/HashGeneratorPage';
import PasswordGeneratorPage from './pages/tools/PasswordGeneratorPage';
import HashVerifierPage from './pages/tools/HashVerifierPage';
import RegexTesterPage from './pages/tools/RegexTesterPage';
import RegexGeneratorPage from './pages/tools/RegexGeneratorPage';
import TimestampConverterPage from './pages/tools/TimestampConverterPage';
import TextDiffPage from './pages/tools/TextDiffPage';
import UuidGeneratorPage from './pages/tools/UuidGeneratorPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="tools" element={<ToolsPage />} />
          <Route path="tools/:category" element={<ToolsPage />} />

          {/* Tool Pages */}
          <Route path="json-formatter" element={<JsonFormatterPage />} />
          <Route path="json-validator" element={<JsonValidatorPage />} />
          <Route path="json-minifier" element={<JsonMinifierPage />} />
          <Route path="json-viewer" element={<JsonViewerPage />} />
          <Route path="json-to-yaml" element={<JsonToYamlPage />} />
          <Route path="yaml-to-json" element={<YamlToJsonPage />} />
          <Route path="base64" element={<Base64Page />} />
          <Route path="url-encoder" element={<UrlEncoderPage />} />
          <Route path="html-entity-encoder" element={<HtmlEntityEncoderPage />} />
          <Route path="binary-encoder" element={<BinaryEncoderPage />} />
          <Route path="hex-encoder" element={<HexEncoderPage />} />
          <Route path="jwt-decoder" element={<JwtDecoderPage />} />
          <Route path="hash-generator" element={<HashGeneratorPage />} />
          <Route path="password-generator" element={<PasswordGeneratorPage />} />
          <Route path="hash-verifier" element={<HashVerifierPage />} />
          <Route path="regex-tester" element={<RegexTesterPage />} />
          <Route path="regex-generator" element={<RegexGeneratorPage />} />
          <Route path="timestamp-converter" element={<TimestampConverterPage />} />
          <Route path="text-diff" element={<TextDiffPage />} />
          <Route path="uuid-generator" element={<UuidGeneratorPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
